// material-ui
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import { createPortal } from 'react-dom';

// ==============================|| LOADER ||============================== //

export default function Loader() {
  return createPortal(
    <Box sx={{ position: 'fixed', top: 0, left: 0, zIndex: 1301, width: '100%' }}>
      <LinearProgress color="primary" />
    </Box>,
    document.body,
  );
}
